import { format, normalizeSSNDigits } from "./SSN";

export const formatPastedSSN = (existingSsn: string, pastedText: string): string => {
  const combined = `${normalizeSSNDigits(existingSsn)}${normalizeSSNDigits(pastedText)}`.slice(0, 9);
  return format(combined, false);
};

const blockNonDigitPrintableKeys = (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (e.key.length === 1 && !/^\d$/.test(e.key) && !e.ctrlKey && !e.metaKey) {
    e.preventDefault();
  }
};

export const handleSSNKeyDown = (
  e: React.KeyboardEvent<HTMLInputElement>,
  currentSsn: string,
  updateSSN: (nextValue: string) => void,
  isSSNVisible: boolean
) => {
  if (isSSNVisible) {
    blockNonDigitPrintableKeys(e);
    return;
  }

  if (e.key === "Backspace") {
    e.preventDefault();
    const digits = normalizeSSNDigits(currentSsn);
    if (digits.length > 0) {
      updateSSN(format(digits.slice(0, -1), false));
    }
    return;
  }

  if (/^\d$/.test(e.key)) {
    e.preventDefault();
    const digits = normalizeSSNDigits(currentSsn);
    if (digits.length < 9) {
      updateSSN(format(`${digits}${e.key}`, false));
    }
    return;
  }

  if (e.key.length === 1 && !e.ctrlKey && !e.metaKey) {
    e.preventDefault();
  }
};
